<template lang="pug">
v-app
  em-menu
  v-content
    v-container
      .content-area
        .desciption
          h1.display-1 カテゴリー管理
          p アプリの商品カテゴリーの追加/編集/削除ができます
          .alert(v-show="cache != null")
            v-alert(:value='cache.result == true', type='success')
              | キャッシュの更新に成功しました。
            v-alert(:value='cache.result == false', type='error')
              | キャッシュの更新に失敗しました。
              br
              | {{ cache.message }}
          v-layout(row, justify-center)
          v-dialog(v-model='dialog', persistent, max-width='600px')
            template(v-slot:activator='{ on }')
              v-btn(color='primary', depressed, v-on='on') 新規追加
            v-card
              v-card-title
                span.headline 商品カテゴリー追加
              v-card-text
                v-container(grid-list-md)
                  v-layout(wrap)
                    v-flex(xs12)
                      v-text-field(label='Category Name*', required='', v-model='categoryName')
                  small *indicates required field
              v-card-actions
                v-spacer
                v-btn(color='blue darken-1', flat='', @click='dialog = false') Close
                v-btn(color='blue darken-1', flat='', @click='addCategory', :disabled="!categoryInputValid") Save
          v-data-table.elevation-1(:headers='headers', :items='data')
            template(v-slot:items='props')
              td {{ props.item.order }}
              td.text-xs {{ props.item.category }}
              td.text-xs(v-if="props.item.isPublish") 公開
              td.text-xs(v-else) 非公開
              td.text-xs
                v-btn(v-if="props.item.isPublish", small, color='warning', depressed, @click="turnPublish(props.item.categoryId, props.item.category, props.item.isPublish)") 非公開にする
                v-btn(v-else, small, color='info', depressed, @click="turnPublish(props.item.categoryId, props.item.category, props.item.isPublish)") 公開する
                v-dialog(v-model='props.item.deleteDialog', persistent, max-width='290')
                  template(v-slot:activator='{ on }')
                    v-btn(color='error', dark, small, v-on='on') 削除
                  v-card
                    v-card-title.headline 確認してください。
                    v-card-text カテゴリー名: {{ props.item.category }}
                      br
                      | 本当に削除してもよろしいですか。削除をすると、元に戻すことはできません。
                    v-card-actions
                      v-spacer
                      v-btn(color='green darken-1', flat='', @click='props.item.deleteDialog = false') Cancel
                      v-btn(color='error darken-1', flat='', @click='deleteCategory(props.index)') Delete
</template>
<script>
import API from '@/api/api.js'
import EmMenu from '@/components/organisms/EmMenu.vue'

export default {
  name: 'category',
  components: {
    EmMenu
  },
  data () {
    return {
      cache: {
        result: null,
        message: ''
      },
      dialog: false,
      categoryName: '',
      headers: [ // テーブルのヘッダーを構造的に定義
        {
          text: '順番',
          align: 'left',
          sortable: false,
          value: 'order'
        },
        { text: 'カテゴリー名', align: 'left', value: 'category', sortable: false },
        { text: '公開ステータス', align: 'left', value: 'isPublish', sortable: false },
        { text: '', value: 'action', sortable: false }
      ],
      data: []
    }
  },
  computed: {
    getCategoryData () {
      return this.data
    },
    categoryInputValid () {
      return this.categoryName.length > 0
    }
  },
  methods: {
    // 新規のカテゴリーを追加する
    addCategory () {
      if (this.categoryName.length === 0) {
        alert('カテゴリー名を入力してください')
        return
      }
      API.AddCategory({ param: { category_name: this.categoryName } }).then(result => {
        alert('カテゴリー: ' + this.categoryName + 'が追加されました.')
        this.updateCache()
        this.getCategoryList()
        this.dialog = false
        this.categoryName = ''
      }).catch(() => {
        alert('エラーが発生しました')
      })
    },
    // カテゴリーを削除する
    deleteCategory (index) {
      let categoryId = this.data[index].categoryId
      let categoryName = this.data[index].category
      API.DeleteCategory({ param: { category_id: categoryId } }).then(result => {
        alert('カテゴリー: ' + categoryName + 'を削除しました.\nこのカテゴリに紐づいている商品は、カテゴリーを変更してください')
        this.updateCache()
        this.getCategoryList()
        this.data[index].deleteDialog = false
      }).catch(() => {
        alert('エラーが発生しました')
      })
    },
    // カテゴリーの公開・非公開を切り替える
    turnPublish (categoryId, categoryName, isPublish) {
      API.TurnPublishCategory({ param: { category_id: categoryId } }).then(result => {
        if (isPublish) {
          alert('カテゴリー: ' + categoryName + 'が非公開になりました.')
        } else {
          alert('カテゴリー: ' + categoryName + 'が公開されました.')
        }
        this.updateCache()
        this.getCategoryList()
      }).catch(() => {
        alert('エラーが発生しました')
      })
    },
    // カテゴリーの一覧を取得する
    getCategoryList () {
      API.GetCategoryList().then(result => {
        this.data = []
        result.categories.forEach((data, order) => {
          this.data.push({
            categoryId: data.id,
            order: order + 1, // 順番は1からなので、+1する
            category: data.category,
            isPublish: data.is_publish,
            deleteDialog: false
          })
        })
      }).catch(() => {
        alert('エラーが発生しました')
      })
    },
    updateCache () {
      API.UpdateCache().then(result => {
        if (result.message === 'ok') {
          // キャッシュ更新は成功
          this.cache = {
            result: true
          }
        } else if (result.message === 'error') {
          // キャッシュ更新は失敗
          this.cache = {
            result: false,
            message: result.error
          }
        }
      }).catch(() => {
        alert('エラーが発生しました')
      })
    }
  },
  created () {
    this.getCategoryList()
  }
}
</script>
<style lang="stylus" scoped>

.content-area
  display flex
  flex-direction column

</style>
